import { render, staticRenderFns } from "./hairfilesNew.vue?vue&type=template&id=55d9d9fc&scoped=true&"
import script from "./hairfilesNew.vue?vue&type=script&lang=js&"
export * from "./hairfilesNew.vue?vue&type=script&lang=js&"
import style0 from "./hairfilesNew.vue?vue&type=style&index=0&id=55d9d9fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9d9fc",
  null
  
)

export default component.exports